import React from "react";
import { Link } from "react-router-dom";

const PrimaryButton = ({
  text,
  img,
  width,
  event,
  path,
  type = "button",
  uppercase = true,
  mutation = false,
  disabled = false,
}) => {
  return (
    <>
      {path ? (
        <Link
          to={path}
          className={`shadow-light bg-quaternary disabled:bg-quaternary/80 text-white text-center ${
            !mutation
              ? "py-[10.5px] lg:text-[17px] text-xs"
              : "py-[10px] lg:text-[15px] text-xs"
          }  rounded-md ${
            uppercase ? "uppercase" : "normal-case"
          } font-semibold tracking-wider relative z-20 outline-none ${
            width ? width : ""
          }`}
        >
          {text}
          {img && <img src={img} alt="" width={17} height={17} />}
        </Link>
      ) : (
        <button
          type={type}
          className={`shadow-light bg-quaternary disabled:bg-quaternary/80 text-white text-center ${
            !mutation
              ? "py-[10.5px] lg:text-[17px] text-xs"
              : "py-[10px] lg:text-[15px] text-xs"
          }  rounded-md ${
            uppercase ? "uppercase" : "normal-case"
          } font-semibold tracking-wider relative z-20 outline-none ${
            width ? width : ""
          }`}
          disabled={disabled}
          onClick={event}
        >
          {text}
          {img && <img src={img} alt="" width={17} height={17} />}
        </button>
      )}
    </>
  );
};

export default PrimaryButton;
